import { render } from "./BrowserSaver__Card.vue?vue&type=template&id=44b644b0"
import script from "./BrowserSaver__Card.vue?vue&type=script&lang=js"
export * from "./BrowserSaver__Card.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__